import {
  ComponentMap,
  AustracPhoneNum,
  AustracPhoneNumFormModel,
} from '@/editor-map/types';
import { objPathToTitle } from '@/editor-map/title';

const editorType = 'austrac.ifti-dra.PhoneNum';
const title = objPathToTitle;

// eslint-disable-next-line @typescript-eslint/ban-types
export function toFormSchema(data: AustracPhoneNum, readonly = false): object {
  return {
    elements: {
      phoneNum: {
        label: 'Phone Number',
        type: 'text',
        maxLength: 20,
        required: true,
        placeholder: 'Empty value',
        readonly,
      },
    },
  };
}

export function fromFormModel(
  formModel: AustracPhoneNumFormModel,
): AustracPhoneNum {
  return formModel.phoneNum;
}

export function toFormModel(data: AustracPhoneNum): AustracPhoneNumFormModel {
  return { phoneNum: data };
}

export const componentMap: ComponentMap = {
  [editorType]: {
    title,
    toFormModel,
    fromFormModel,
    toFormSchema,
  },
};

export default componentMap;
